"use strict";
/* eslint-disable no-param-reassign */
Object.defineProperty(exports, "__esModule", { value: true });
/** Returns true if the end event is defined @private */
const isDefined = (endEvent) => Object.keys(endEvent).length > 0;
/**
 * Flush both start and end event queues to the event start names and event end
 * objects respectively. Additionally add any available built-in browser timings
 * as event end objects, but only once. Exclude any empty objects.
 *
 * @param profiler - ClientProfiler instance
 * @param opts - The beacon options
 */
function flushEvents(profiler, opts) {
    const { eventEndQueue, eventStartQueue, navigationTimings, resourceTimings, } = profiler;
    // Flush all buffered start and end events that have built up since the last
    // beacon (and clear the queues)
    opts.eventsStart = eventStartQueue.splice(0, eventStartQueue.length);
    opts.eventsEnd = eventEndQueue.splice(0, eventEndQueue.length);
    // Grab the built-in browser events if they're available
    const DOMContentLoaded = navigationTimings.getDOMContentLoadedTimeOnce();
    const fullyLoaded = resourceTimings.getFullyLoadedTimeOnce();
    if (isDefined(DOMContentLoaded))
        opts.eventsEnd.push(DOMContentLoaded);
    if (isDefined(fullyLoaded))
        opts.eventsEnd.push(fullyLoaded);
    // >>> START PERF-777 >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
    // Always add TTFB even if it's not supported by the browser to match legacy
    // behavior and not break existing monitoring. (See PERF-777.)
    const TTFB = navigationTimings.getTimeToFirstByteOnce();
    if (isDefined(TTFB))
        opts.eventsEnd.push(TTFB);
    // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< END PERF-777 <<<
    // Remove any empty objects if they somehow made it into the queue. (Shouldn't
    // happen, but just in case.)
    opts.eventsEnd = opts.eventsEnd.filter(isDefined);
}
exports.default = flushEvents;
